/**
 * Compose the human-readable card title from the new 3-field schema.
 * Falls back to the legacy single `name` field if the new fields are blank
 * (back-compat with cards added before the schema split).
 */
export function cardDisplayName(card) {
  if (!card) return "";
  const parts = [card.set_name, card.player_name, card.card_name]
    .map((p) => (p == null ? "" : String(p).trim()))
    .filter(Boolean);
  if (parts.length) return parts.join(" · ");
  return (card.name || "").trim();
}

/** Same as cardDisplayName but returns the player_name first if available, useful for compact UI. */
export function cardShortName(card) {
  if (!card) return "";
  return (card.player_name || card.card_name || card.set_name || card.name || "").trim();
}
